var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisneyPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    zoomAndPan: "magnify",
    viewBox: "0 0 180 67.499998",
    height: 90,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4001d315cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 1 L 135 1 L 135 34 L 47 34 Z M 47 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72081e3e8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47.394531 23.945312 C 47.296875 24.089844 47.261719 24.289062 47.328125 24.46875 C 47.394531 24.648438 47.523438 24.777344 47.6875 24.828125 L 48.972656 25.269531 C 49.054688 25.285156 49.117188 25.300781 49.199219 25.300781 C 49.445312 25.300781 49.671875 25.171875 49.800781 24.976562 C 58.542969 12.046875 73.082031 4.304688 88.625 4.304688 C 107.492188 4.304688 124.519531 15.664062 131.859375 33.125 C 131.976562 33.371094 132.21875 33.535156 132.480469 33.535156 L 134.027344 33.535156 C 134.320312 33.535156 134.5625 33.289062 134.5625 32.992188 C 134.5625 32.929688 134.546875 32.863281 134.53125 32.796875 C 124.226562 7.316406 95.300781 -4.941406 69.953125 5.417969 C 60.773438 9.164062 52.910156 15.628906 47.394531 23.945312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 805.367057,
    gradientTransform: "matrix(0.162783, 0, 0, 0.163657, 4.958736, -5.355925)",
    y1: 169.680566,
    x2: 251.488238,
    gradientUnits: "userSpaceOnUse",
    y2: 94.793432,
    id: "32d2041218"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.298828%, 10.998535%, 31.399536%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.280518%, 11.05957%, 31.65741%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.262207%, 11.122131%, 31.915283%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 11.187744%, 32.191467%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.221008%, 11.253357%, 32.469177%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.199646%, 11.31897%, 32.745361%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.17981%, 11.386108%, 33.023071%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.159973%, 11.451721%, 33.299255%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.140137%, 11.517334%, 33.576965%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.118774%, 11.582947%, 33.853149%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.098938%, 11.64856%, 34.130859%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.079102%, 11.714172%, 34.407043%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.059265%, 11.781311%, 34.684753%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.037903%, 11.846924%, 34.960938%)",
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.018066%, 11.912537%, 35.238647%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.99823%, 11.978149%, 35.514832%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.978394%, 12.043762%, 35.792542%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.957031%, 12.109375%, 36.068726%)",
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.937195%, 12.176514%, 36.346436%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.915833%, 12.242126%, 36.624146%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.895996%, 12.307739%, 36.901855%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.87616%, 12.373352%, 37.17804%)",
    offset: 0.0820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.856323%, 12.438965%, 37.45575%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.834961%, 12.504578%, 37.731934%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.815125%, 12.571716%, 38.009644%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.795288%, 12.637329%, 38.285828%)",
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.775452%, 12.702942%, 38.563538%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.754089%, 12.768555%, 38.839722%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.734253%, 12.834167%, 39.117432%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.714417%, 12.89978%, 39.393616%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.69458%, 12.966919%, 39.671326%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.673218%, 13.032532%, 39.94751%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.653381%, 13.098145%, 40.22522%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.632019%, 13.163757%, 40.501404%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.612183%, 13.22937%, 40.779114%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.592346%, 13.294983%, 41.055298%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.57251%, 13.362122%, 41.333008%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.551147%, 13.427734%, 41.609192%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.531311%, 13.493347%, 41.886902%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.511475%, 13.55896%, 42.164612%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.491638%, 13.624573%, 42.442322%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.470276%, 13.690186%, 42.718506%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.450439%, 13.757324%, 42.996216%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.430603%, 13.822937%, 43.2724%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.410767%, 13.88855%, 43.55011%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.389404%, 13.954163%, 43.826294%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.369568%, 14.019775%, 44.104004%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.348206%, 14.085388%, 44.380188%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.328369%, 14.152527%, 44.657898%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.308533%, 14.21814%, 44.934082%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.288696%, 14.283752%, 45.211792%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.267334%, 14.349365%, 45.487976%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.247498%, 14.414978%, 45.765686%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.227661%, 14.480591%, 46.04187%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.207825%, 14.547729%, 46.31958%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.186462%, 14.613342%, 46.595764%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.166626%, 14.678955%, 46.873474%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.14679%, 14.744568%, 47.149658%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.126953%, 14.810181%, 47.427368%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.102539%, 14.959717%, 47.697449%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.078125%, 15.109253%, 47.969055%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.046082%, 15.426636%, 48.225403%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 15.745544%, 48.483276%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.985046%, 16.062927%, 48.739624%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.954529%, 16.381836%, 48.997498%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.922485%, 16.699219%, 49.255371%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.891968%, 17.018127%, 49.513245%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.859924%, 17.33551%, 49.769592%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.829407%, 17.654419%, 50.027466%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.797363%, 17.971802%, 50.283813%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.766846%, 18.289185%, 50.541687%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.734802%, 18.606567%, 50.798035%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.704285%, 18.925476%, 51.055908%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.672241%, 19.242859%, 51.312256%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.641724%, 19.561768%, 51.570129%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.60968%, 19.87915%, 51.828003%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.579163%, 20.198059%, 52.085876%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.547119%, 20.515442%, 52.342224%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.516602%, 20.834351%, 52.600098%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.486084%, 21.151733%, 52.856445%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.455566%, 21.470642%, 53.114319%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.423523%, 21.788025%, 53.370667%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.393005%, 22.106934%, 53.62854%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.360962%, 22.424316%, 53.884888%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.330444%, 22.743225%, 54.142761%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.298401%, 23.060608%, 54.400635%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.267883%, 23.379517%, 54.658508%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.23584%, 23.696899%, 54.914856%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.205322%, 24.015808%, 55.172729%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.173279%, 24.333191%, 55.429077%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.142761%, 24.6521%, 55.686951%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.110718%, 24.969482%, 55.943298%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.0802%, 25.286865%, 56.201172%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.049683%, 25.604248%, 56.45752%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.019165%, 25.923157%, 56.715393%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.987122%, 26.24054%, 56.973267%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.956604%, 26.559448%, 57.23114%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.924561%, 26.876831%, 57.487488%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.894043%, 27.19574%, 57.745361%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.862%, 27.513123%, 58.001709%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.831482%, 27.832031%, 58.259583%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.799438%, 28.149414%, 58.51593%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.768921%, 28.468323%, 58.773804%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.736877%, 28.785706%, 59.030151%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.70636%, 29.104614%, 59.288025%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.674316%, 29.421997%, 59.545898%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.643799%, 29.740906%, 59.803772%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.611755%, 30.058289%, 60.06012%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.581238%, 30.377197%, 60.317993%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.55072%, 30.69458%, 60.574341%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.520203%, 31.013489%, 60.832214%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.488159%, 31.330872%, 61.088562%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.457642%, 31.64978%, 61.346436%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.425598%, 31.967163%, 61.604309%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.395081%, 32.284546%, 61.862183%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.363037%, 32.601929%, 62.11853%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.33252%, 32.920837%, 62.376404%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.300476%, 33.23822%, 62.632751%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.269958%, 33.557129%, 62.890625%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.237915%, 33.874512%, 63.146973%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.207397%, 34.19342%, 63.404846%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.175354%, 34.510803%, 63.661194%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.144836%, 34.829712%, 63.919067%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.114319%, 35.2005%, 64.18457%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.083801%, 35.571289%, 64.450073%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.053284%, 36.090088%, 64.735413%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.024292%, 36.608887%, 65.022278%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.993774%, 37.127686%, 65.309143%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.964783%, 37.646484%, 65.596008%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.934265%, 38.165283%, 65.881348%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.905273%, 38.684082%, 66.168213%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.874756%, 39.202881%, 66.455078%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.845764%, 39.723206%, 66.741943%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.815247%, 40.242004%, 67.027283%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.786255%, 40.760803%, 67.314148%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.755737%, 41.279602%, 67.601013%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.726746%, 41.798401%, 67.887878%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.696228%, 42.3172%, 68.173218%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.667236%, 42.835999%, 68.460083%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.636719%, 43.354797%, 68.746948%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.607727%, 43.873596%, 69.033813%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.577209%, 44.392395%, 69.319153%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.548218%, 44.911194%, 69.606018%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.5177%, 45.429993%, 69.892883%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.488708%, 45.948792%, 70.179749%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.458191%, 46.46759%, 70.465088%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.429199%, 46.987915%, 70.751953%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.398682%, 47.506714%, 71.038818%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.36969%, 48.025513%, 71.325684%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.339172%, 48.544312%, 71.611023%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.310181%, 49.06311%, 71.897888%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.279663%, 49.581909%, 72.183228%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.250671%, 50.100708%, 72.470093%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.220154%, 50.619507%, 72.756958%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.191162%, 51.138306%, 73.043823%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.160645%, 51.657104%, 73.329163%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.131653%, 52.175903%, 73.616028%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.101135%, 52.694702%, 73.902893%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.072144%, 53.213501%, 74.189758%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.043152%, 53.7323%, 74.475098%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.01416%, 54.251099%, 74.761963%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.601624%, 54.776001%, 75.05188%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.189087%, 55.302429%, 75.341797%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.968811%, 55.828857%, 75.631714%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.750061%, 56.355286%, 75.923157%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.529785%, 56.881714%, 76.213074%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.311035%, 57.409668%, 76.504517%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.090759%, 57.936096%, 76.794434%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.872009%, 58.46405%, 77.085876%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.653259%, 58.990479%, 77.375793%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.434509%, 59.518433%, 77.667236%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.214233%, 60.044861%, 77.957153%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.995483%, 60.572815%, 78.248596%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.775208%, 61.099243%, 78.540039%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.556458%, 61.625671%, 78.831482%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.336182%, 62.1521%, 79.121399%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.117432%, 62.680054%, 79.412842%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.897156%, 63.206482%, 79.702759%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.678406%, 63.734436%, 79.994202%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.459656%, 64.260864%, 80.284119%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.240906%, 64.788818%, 80.575562%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.02063%, 65.315247%, 80.865479%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.80188%, 65.841675%, 81.156921%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.581604%, 66.368103%, 81.446838%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.362854%, 66.896057%, 81.738281%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.142578%, 67.422485%, 82.028198%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.923828%, 67.950439%, 82.319641%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.705078%, 68.476868%, 82.609558%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.486328%, 69.004822%, 82.901001%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.266052%, 69.53125%, 83.190918%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.047302%, 70.057678%, 83.482361%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.827026%, 70.584106%, 83.772278%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.608276%, 71.112061%, 84.063721%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.388%, 71.638489%, 84.353638%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.16925%, 72.166443%, 84.645081%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.9505%, 72.692871%, 84.934998%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.73175%, 73.220825%, 85.22644%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.511475%, 73.747253%, 85.516357%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.292725%, 74.273682%, 85.8078%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.072449%, 74.80011%, 86.097717%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.853699%, 75.328064%, 86.38916%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.633423%, 75.854492%, 86.679077%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.414673%, 76.382446%, 86.97052%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.195923%, 76.908875%, 87.260437%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.977173%, 77.436829%, 87.55188%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.756897%, 77.963257%, 87.841797%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.538147%, 78.491211%, 88.13324%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.317871%, 79.017639%, 88.424683%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.099121%, 79.544067%, 88.716125%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.878845%, 80.070496%, 89.006042%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.660095%, 80.59845%, 89.297485%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.441345%, 81.124878%, 89.587402%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.222595%, 81.652832%, 89.878845%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.002319%, 82.17926%, 90.168762%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.783569%, 82.707214%, 90.460205%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.563293%, 83.233643%, 90.750122%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.344543%, 83.760071%, 91.041565%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.124268%, 84.286499%, 91.331482%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.905518%, 84.814453%, 91.622925%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.686768%, 85.340881%, 91.912842%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.468018%, 85.868835%, 92.204285%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.247742%, 86.395264%, 92.494202%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.028992%, 86.923218%, 92.785645%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.808716%, 87.449646%, 93.075562%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.589966%, 87.976074%, 93.367004%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.36969%, 88.502502%, 93.656921%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.15094%, 89.030457%, 93.948364%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.93219%, 89.556885%, 94.238281%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.71344%, 90.084839%, 94.529724%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.493164%, 90.611267%, 94.819641%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.274414%, 91.139221%, 95.111084%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.054138%, 91.665649%, 95.401001%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.835388%, 92.192078%, 95.692444%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.615112%, 92.718506%, 95.982361%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.396362%, 93.24646%, 96.273804%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.177612%, 93.772888%, 96.563721%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.958862%, 94.300842%, 96.855164%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.738586%, 94.827271%, 97.145081%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.519836%, 95.355225%, 97.436523%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.299561%, 95.881653%, 97.72644%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.080811%, 96.409607%, 98.017883%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.860535%, 96.936035%, 98.309326%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.641785%, 97.462463%, 98.600769%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.421509%, 97.988892%, 98.890686%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.202759%, 98.516846%, 99.182129%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.984009%, 99.043274%, 99.472046%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.765259%, 99.571228%, 99.763489%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.081116%, 99.784851%, 99.880981%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.398499%, 100%, 100%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.398499%, 100%, 100%)",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#101c50",
    d: "M 80.144531 45.136719 L 80.292969 45.152344 C 81.347656 45.300781 82.390625 45.480469 83.171875 45.839844 C 83.855469 46.117188 84.410156 46.644531 84.734375 47.3125 C 85.335938 48.523438 85.371094 49.949219 84.832031 51.175781 C 84.425781 52.058594 83.546875 52.796875 82.734375 53.1875 C 81.902344 53.582031 81.023438 53.828125 80.113281 53.910156 C 78.402344 54.074219 76.695312 53.761719 75.148438 53.027344 C 74.269531 52.601562 73.179688 51.847656 72.640625 50.882812 C 72.234375 50.160156 72.265625 49.277344 72.738281 48.589844 C 73.519531 47.527344 75.179688 47.28125 76.433594 47.332031 C 77.65625 47.410156 78.859375 47.625 80.015625 47.984375 C 80.257812 48.082031 81.1875 48.441406 81.347656 48.605469 C 81.480469 48.722656 81.527344 48.886719 81.480469 49.046875 C 81.269531 49.6875 79.722656 50.03125 79.28125 50.097656 C 78.09375 50.277344 77.476562 49.816406 76.109375 49.292969 C 75.75 49.148438 75.359375 49.03125 74.984375 48.984375 C 74.367188 48.917969 73.617188 49.097656 73.503906 49.769531 C 73.4375 50.113281 73.84375 50.441406 74.15625 50.585938 C 74.789062 50.882812 75.488281 51.027344 76.1875 51.027344 C 78.304688 51.0625 80.683594 50.71875 82.40625 49.472656 C 82.652344 49.308594 82.878906 49.046875 82.878906 48.738281 C 82.878906 48.097656 81.789062 47.722656 81.789062 47.722656 C 80.632812 47.230469 78.46875 47.003906 77.363281 46.90625 C 76.207031 46.804688 74.367188 46.660156 73.925781 46.578125 C 73.472656 46.527344 73.015625 46.414062 72.59375 46.25 C 72.167969 46.054688 71.84375 45.675781 71.695312 45.234375 C 71.5 44.433594 71.746094 43.453125 72.183594 42.8125 C 73.339844 41.144531 76.042969 40.503906 78.0625 40.261719 C 80.015625 40.015625 83.1875 40.015625 85.109375 41.046875 C 85.402344 41.210938 85.566406 41.355469 85.5 41.667969 C 85.371094 42.222656 84.945312 42.683594 84.378906 42.8125 C 83.808594 42.992188 82.636719 43.058594 82.113281 43.109375 C 79.804688 43.238281 77.003906 43.171875 74.789062 43.777344 C 74.609375 43.828125 74.316406 43.910156 74.21875 44.023438 C 73.878906 44.402344 74.855469 44.515625 75.066406 44.546875 C 75.113281 44.5625 75.164062 44.5625 75.210938 44.582031 L 80.144531 45.136719 M 66.339844 34.746094 C 66.339844 34.746094 66.714844 34.171875 67.023438 33.746094 C 67.742188 32.8125 68.539062 31.960938 69.417969 31.195312 C 69.660156 30.996094 69.9375 30.75 69.9375 30.75 C 69.9375 30.75 69.5 30.800781 69.253906 30.851562 C 68.667969 30.964844 67.789062 31.554688 67.351562 31.929688 C 66.632812 32.550781 65.835938 33.550781 66.195312 34.449219 C 66.257812 34.582031 66.339844 34.746094 66.339844 34.746094 M 70.34375 35.824219 C 71.46875 35.742188 72.558594 35.414062 73.535156 34.859375 C 74.511719 34.320312 75.929688 33.253906 75.78125 31.996094 C 75.75 31.617188 75.503906 31.277344 75.148438 31.128906 C 74.707031 30.949219 74.496094 30.964844 73.925781 31.128906 C 73.585938 31.210938 73.257812 31.355469 72.964844 31.539062 C 71.859375 32.191406 70.28125 33.582031 69.417969 34.695312 C 69.222656 34.957031 69.011719 35.253906 68.863281 35.449219 C 68.765625 35.578125 68.683594 35.695312 68.703125 35.710938 C 68.734375 35.859375 69.90625 35.839844 70.34375 35.824219 M 67.464844 37.953125 C 67.316406 38.164062 67.203125 38.378906 67.089844 38.589844 C 67.007812 38.722656 66.925781 38.820312 66.8125 38.917969 C 66.519531 39.132812 66.257812 39.148438 65.984375 38.902344 C 65.574219 38.527344 65.347656 38 65.332031 37.460938 C 65.347656 37.234375 65.347656 37.003906 65.316406 36.773438 C 65.234375 36.445312 64.910156 36.101562 64.730469 35.777344 C 64.5 35.316406 64.371094 34.828125 64.324219 34.320312 C 64.257812 33.011719 64.941406 31.800781 65.835938 30.832031 C 66.78125 29.835938 67.9375 29.050781 69.207031 28.507812 C 70.425781 28.003906 72.199219 27.640625 73.519531 28.117188 C 74.039062 28.296875 74.496094 28.609375 74.855469 29.015625 C 74.902344 29.097656 74.96875 29.164062 75.035156 29.230469 C 75.148438 29.261719 75.261719 29.296875 75.375 29.3125 C 75.847656 29.425781 76.285156 29.621094 76.660156 29.917969 C 77.132812 30.277344 77.441406 30.800781 77.558594 31.375 C 77.816406 32.585938 77.117188 33.925781 76.320312 34.730469 C 74.96875 36.121094 73.617188 37.101562 71.890625 37.789062 C 71.125 38.082031 69.9375 38.363281 69.074219 38.296875 C 68.816406 38.28125 68.523438 38.199219 68.261719 38.183594 C 68.035156 38.148438 67.804688 38.082031 67.59375 38 C 67.5625 37.984375 67.480469 37.953125 67.464844 37.953125 M 69.011719 40.652344 C 69.074219 40.667969 69.15625 40.6875 69.222656 40.71875 C 69.824219 40.949219 70.085938 41.519531 70.230469 42.140625 C 70.574219 43.582031 70.71875 46.789062 70.785156 48.035156 C 70.832031 48.964844 70.851562 49.898438 70.882812 50.832031 C 70.914062 51.617188 70.980469 52.664062 70.816406 53.402344 C 70.753906 53.695312 70.574219 53.957031 70.328125 54.136719 C 70.035156 54.316406 69.386719 54.335938 69.027344 54.269531 C 68.132812 54.089844 67.855469 53.515625 67.726562 52.617188 C 67.414062 50.503906 67.5625 46.347656 67.742188 44.597656 C 67.804688 44.023438 68.019531 42.160156 68.3125 41.390625 C 68.425781 41.109375 68.652344 40.570312 69.011719 40.652344 M 41.90625 44.171875 C 41.90625 44.171875 40.589844 44.269531 39.660156 44.367188 C 38.503906 44.5 36.308594 44.875 35.054688 45.332031 C 34.679688 45.464844 33.914062 45.792969 33.847656 46.183594 C 33.785156 46.578125 34.027344 46.90625 34.304688 47.230469 C 34.46875 47.429688 35.378906 48.296875 35.625 48.507812 C 36.699219 49.410156 38.863281 50.800781 40.457031 51.453125 C 41.011719 51.683594 41.90625 52.011719 41.90625 52.011719 C 41.90625 52.011719 41.84375 49.410156 41.859375 46.855469 C 41.875 45.511719 41.90625 44.171875 41.90625 44.171875 M 66.210938 45.21875 C 66.292969 45.921875 66.113281 47.230469 66.082031 47.410156 C 65.984375 47.902344 65.851562 48.378906 65.671875 48.851562 C 65.445312 49.359375 65.203125 49.851562 64.941406 50.339844 C 64.371094 51.289062 63.671875 52.15625 62.855469 52.910156 C 60.578125 54.890625 57.046875 56.019531 54.003906 56.398438 C 51.804688 56.660156 49.574219 56.59375 47.394531 56.199219 C 46.644531 56.070312 45.519531 55.808594 45.519531 55.808594 C 45.519531 55.808594 45.519531 56.25 45.488281 56.578125 C 45.457031 56.804688 45.390625 57.019531 45.308594 57.214844 C 45.164062 57.527344 44.855469 57.738281 44.511719 57.789062 C 44.054688 57.871094 43.566406 57.902344 43.144531 57.722656 C 42.445312 57.429688 42.199219 56.773438 42.085938 56.019531 C 41.988281 55.414062 41.890625 54.367188 41.890625 54.367188 C 41.890625 54.367188 41.371094 54.121094 40.945312 53.910156 C 39.660156 53.269531 38.421875 52.5 37.25 51.632812 C 36.941406 51.40625 35.640625 50.292969 35.347656 50.03125 C 34.53125 49.261719 33.800781 48.476562 33.246094 47.492188 C 32.808594 46.726562 32.695312 46.039062 33.019531 45.21875 C 33.476562 44.074219 35.101562 43.222656 36.210938 42.730469 C 37.023438 42.371094 39.578125 41.535156 40.636719 41.375 C 41.140625 41.308594 41.90625 41.160156 41.957031 41.128906 C 41.972656 41.109375 41.988281 41.09375 42.003906 41.078125 C 42.019531 41.046875 42.070312 39.917969 42.070312 39.507812 C 42.054688 39.097656 42.363281 36.429688 42.460938 35.859375 C 42.507812 35.546875 42.738281 34.367188 42.980469 34.074219 C 43.128906 33.859375 43.40625 33.878906 43.632812 34.023438 C 44.835938 34.777344 45.210938 37.414062 45.308594 38.753906 C 45.359375 39.574219 45.390625 40.800781 45.390625 40.800781 C 45.390625 40.800781 46.789062 40.765625 47.636719 40.785156 C 48.515625 40.816406 49.378906 40.914062 50.242188 41.078125 C 51.347656 41.257812 53.496094 41.734375 54.734375 42.355469 C 55.742188 42.878906 56.703125 43.746094 57.011719 44.664062 C 57.304688 45.511719 57.257812 46.101562 56.816406 46.855469 C 56.328125 47.722656 55.402344 48.359375 54.457031 48.410156 C 54.179688 48.425781 53.121094 48.28125 52.796875 48.035156 C 52.683594 47.9375 52.667969 47.753906 52.765625 47.625 C 52.796875 47.574219 53.285156 47.3125 53.578125 47.167969 C 53.710938 47.085938 53.839844 47.003906 53.953125 46.90625 C 54.199219 46.691406 54.410156 46.445312 54.394531 46.183594 C 54.359375 45.824219 53.984375 45.613281 53.628906 45.464844 C 51.933594 44.792969 48.582031 44.238281 46.953125 44.140625 C 46.320312 44.105469 45.40625 44.074219 45.40625 44.074219 L 45.601562 53.105469 C 45.601562 53.105469 46.351562 53.253906 46.9375 53.351562 C 47.277344 53.402344 48.710938 53.53125 49.085938 53.550781 C 51.984375 53.632812 55.238281 53.371094 57.890625 52.09375 C 59.066406 51.535156 60.140625 50.847656 60.953125 49.914062 C 62.058594 48.625 62.597656 46.921875 62.433594 45.234375 C 62.269531 43.304688 60.921875 41.011719 59.847656 39.621094 C 56.996094 35.941406 52.113281 32.910156 47.832031 31.144531 C 43.453125 29.328125 39.125 28.296875 34.46875 28.117188 C 33.261719 28.066406 30.660156 28.132812 29.324219 28.492188 C 29.128906 28.542969 28.949219 28.609375 28.769531 28.65625 C 28.625 28.691406 28.476562 28.753906 28.347656 28.835938 C 28.316406 28.871094 28.28125 28.902344 28.28125 28.902344 C 28.28125 28.902344 28.363281 28.953125 28.445312 28.984375 C 28.589844 29.050781 29.175781 29.082031 29.488281 29.148438 C 29.746094 29.179688 29.992188 29.328125 30.15625 29.539062 C 30.269531 29.6875 30.269531 29.902344 30.136719 30.046875 C 29.828125 30.40625 28.707031 30.34375 28.21875 30.261719 C 27.730469 30.179688 27.0625 30.015625 26.949219 29.574219 C 26.816406 29.050781 27.0625 28.527344 27.339844 28.035156 C 27.875 27.070312 28.671875 26.5625 29.8125 26.25 C 31.523438 25.792969 33.261719 25.515625 35.023438 25.433594 C 38.488281 25.300781 41.777344 25.90625 45.148438 26.9375 C 47.296875 27.609375 49.394531 28.429688 51.429688 29.394531 C 53.007812 30.179688 54.539062 31.046875 56.019531 31.980469 C 56.394531 32.226562 58.558594 33.828125 58.886719 34.105469 C 59.585938 34.679688 60.496094 35.515625 61.164062 36.167969 C 62.449219 37.445312 64.046875 39.410156 64.828125 40.964844 C 65.007812 41.339844 65.152344 41.699219 65.398438 42.140625 C 65.59375 42.566406 65.753906 42.992188 65.886719 43.433594 C 65.949219 43.679688 66.03125 44.058594 66.046875 44.074219 C 66.082031 44.15625 66.242188 44.925781 66.210938 45.21875 M 109.871094 43.207031 C 108.242188 43.582031 103.960938 43.796875 103.960938 43.796875 L 103.421875 45.496094 C 103.421875 45.496094 105.554688 45.316406 107.117188 45.480469 C 107.117188 45.480469 107.621094 45.414062 107.6875 46.054688 C 107.703125 46.460938 107.6875 46.871094 107.640625 47.28125 C 107.640625 47.28125 107.605469 47.65625 107.070312 47.753906 C 106.484375 47.855469 102.460938 48 102.460938 48 L 101.8125 50.210938 C 101.8125 50.210938 101.566406 50.71875 102.121094 50.570312 C 102.625 50.441406 106.839844 49.636719 107.378906 49.753906 C 107.964844 49.898438 108.617188 50.683594 108.4375 51.40625 C 108.207031 52.289062 104.007812 54.988281 101.453125 54.808594 C 101.453125 54.808594 100.101562 54.890625 98.980469 53.074219 C 97.886719 51.339844 99.351562 48.050781 99.351562 48.050781 C 99.351562 48.050781 98.6875 46.511719 99.175781 45.988281 C 99.175781 45.988281 99.46875 45.726562 100.3125 45.660156 L 101.339844 43.535156 C 101.339844 43.535156 100.167969 43.613281 99.46875 42.746094 C 98.816406 41.929688 98.765625 41.554688 99.253906 41.324219 C 99.792969 41.0625 104.675781 40.160156 108.046875 40.277344 C 108.046875 40.277344 109.21875 40.160156 110.226562 42.207031 C 110.226562 42.191406 110.714844 43.007812 109.871094 43.207031 M 97.222656 51.453125 C 96.78125 52.46875 95.65625 53.566406 94.242188 52.894531 C 92.824219 52.222656 90.628906 47.640625 90.628906 47.640625 C 90.628906 47.640625 89.78125 45.9375 89.617188 45.972656 C 89.617188 45.972656 89.441406 45.644531 89.324219 47.511719 C 89.210938 49.375 89.34375 52.992188 88.609375 53.566406 C 87.910156 54.136719 87.0625 53.910156 86.625 53.238281 C 86.214844 52.582031 86.054688 51.011719 86.28125 48.28125 C 86.542969 45.53125 87.175781 42.601562 87.992188 41.683594 C 88.804688 40.765625 89.457031 41.4375 89.699219 41.683594 C 89.699219 41.683594 90.789062 42.664062 92.566406 45.578125 L 92.875 46.117188 C 92.875 46.117188 94.503906 48.867188 94.664062 48.851562 C 94.664062 48.851562 94.796875 48.984375 94.910156 48.886719 C 95.070312 48.835938 95.007812 47.953125 95.007812 47.953125 C 95.007812 47.953125 94.664062 44.972656 93.183594 39.917969 C 93.054688 39.523438 93.019531 39.097656 93.101562 38.6875 C 93.25 38.101562 93.851562 38.378906 93.851562 38.378906 C 93.851562 38.378906 96.148438 39.539062 97.269531 43.304688 C 98.394531 47.066406 97.660156 50.421875 97.222656 51.453125 M 121.949219 49.195312 C 120.90625 51.027344 117.960938 54.859375 114.019531 53.957031 C 112.71875 57.117188 111.628906 60.308594 111.007812 65.101562 C 111.007812 65.101562 110.878906 66.035156 110.097656 65.707031 C 109.332031 65.445312 108.078125 64.171875 107.835938 62.402344 C 107.558594 60.09375 108.582031 56.183594 110.683594 51.699219 C 110.066406 50.703125 109.65625 49.277344 110.015625 47.25 C 110.015625 47.25 110.535156 43.484375 114.3125 40.082031 C 114.3125 40.082031 114.769531 39.6875 115.03125 39.800781 C 115.324219 39.933594 115.191406 41.144531 114.949219 41.75 C 114.703125 42.355469 113.042969 45.269531 113.042969 45.269531 C 113.042969 45.269531 112 47.230469 112.292969 48.785156 C 114.265625 45.742188 118.757812 39.574219 121.539062 41.519531 C 122.46875 42.191406 122.90625 43.648438 122.90625 45.234375 C 122.90625 46.625 122.582031 48.097656 121.949219 49.195312 M 121.148438 44.367188 C 121.148438 44.367188 120.988281 43.15625 119.816406 44.5 C 118.804688 45.628906 116.964844 47.738281 115.5 50.621094 C 117.046875 50.441406 118.546875 49.605469 118.984375 49.179688 C 119.71875 48.492188 121.425781 46.726562 121.148438 44.367188 M 143.582031 44.089844 L 136.386719 44.089844 C 136.238281 41.636719 135.945312 39.195312 135.492188 36.773438 C 135.441406 36.511719 135.230469 36.332031 134.96875 36.332031 L 133.308594 36.332031 C 133.03125 36.332031 132.820312 36.5625 132.820312 36.824219 C 132.820312 36.855469 132.820312 36.890625 132.835938 36.921875 C 133.308594 39.292969 133.621094 41.683594 133.75 44.089844 L 126.832031 44.089844 C 126.503906 44.089844 126.246094 44.351562 126.246094 44.679688 L 126.246094 46.183594 C 126.246094 46.511719 126.503906 46.773438 126.832031 46.773438 L 133.847656 46.773438 C 133.847656 47.148438 133.847656 47.476562 133.847656 47.789062 C 133.863281 49.785156 133.75 51.78125 133.539062 53.761719 C 133.503906 54.054688 133.71875 54.335938 134.027344 54.367188 C 134.042969 54.367188 134.058594 54.367188 134.074219 54.367188 L 135.621094 54.367188 C 135.914062 54.367188 136.175781 54.136719 136.207031 53.84375 C 136.417969 51.832031 136.515625 49.816406 136.515625 47.804688 C 136.515625 47.492188 136.515625 47.167969 136.515625 46.789062 L 143.613281 46.789062 C 143.941406 46.789062 144.199219 46.527344 144.199219 46.199219 L 144.199219 44.695312 C 144.167969 44.351562 143.90625 44.089844 143.582031 44.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4001d315cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72081e3e8a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#32d2041218)",
    d: "M 47.261719 0 L 47.261719 33.535156 L 134.5625 33.535156 L 134.5625 0 Z M 47.261719 0 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisneyPlus);
export default __webpack_public_path__ + "static/media/Disney_Plus.05456941e238ea72d4a80514b55d0957.svg";
export { ForwardRef as ReactComponent };